import { GetServerSideProps, NextPage } from 'next'

import { getMagazinePageProps } from '~/components/pages/api'
import { ErrorPage, MagazinePage } from '~/components/pages'
import type { ErrorPageProps, MagazinePageProps } from '~/types/page'
import { getParamAsString } from '~/util'

//----- Page Template Selector -----//

const PageTemplate: NextPage<ErrorPageProps | MagazinePageProps> = (props) => {
	if ('errorStatus' in props) return <ErrorPage {...props} />
	return <MagazinePage {...props} />
}

export default PageTemplate

//----- Page Props Selector -----//

export const getServerSideProps: GetServerSideProps = (ctx) => {
	const params: { year?: string; slug?: string } = {}

	if (ctx.params?.route) {
		const { route } = ctx.params

		if (route.length >= 1) params.year = getParamAsString(route[0])
		if (route.length >= 2) params.slug = getParamAsString(route[1])
	}

	return getMagazinePageProps({ ...ctx, params })
}
